import { createQueryKeys } from "@lukemorales/query-key-factory";
import { getGameRequestCounts } from "../api/RequesTixApi";

export const gameRequestCounts = createQueryKeys("gameRequestCounts", {
  getGameRequestCounts: (gamePks: number[]) => ({
    queryKey: ["gameRequestCounts", gamePks],
    queryFn: () => getGameRequestCounts(gamePks),
  }),
});
